import { merge } from 'lodash-es';
import { CHART_TYPES } from '../enums';

export const hasYAxisFormattingOptions = yAxisFormattingOptions => yAxisFormattingOptions;

export default (config, chartJSConfig) => {
  if (config.series[0].seriesType === CHART_TYPES.HORIZONTAL_BAR) {
    return chartJSConfig;
  }

  if (hasYAxisFormattingOptions(config.yAxisFormattingOptions)) {
    /* eslint-disable */
    const formatObject = { options: { scales: { y: { ticks: config.yAxisFormattingOptions } } } };
    return merge(chartJSConfig, formatObject);
  }
};
